import infoIcon from '@/assets/ic_info.svg'
import commentIcon from '@/assets/krea/ic_comment.svg'
import editIcon from '@/assets/krea/ic_edit.svg'
import linkIcon from '@/assets/ic_link.svg'
import pdfIcon from '@/assets/ic_file-text.svg'
import imageIcon from '@/assets/krea/ic_image.svg'
import videoIcon from '@/assets/ic_play.svg'
import trashIcon from '@/assets/krea/ic_trash.svg'

export default [
  { action: 'info', icon: infoIcon },
  { action: 'edit', icon: editIcon, emit: true },
  { action: 'comments', icon: commentIcon },
  { action: 'link', icon: linkIcon },
  { action: 'pdf', icon: pdfIcon },
  { action: 'image', icon: imageIcon },
  { action: 'kreaContentImage', icon: imageIcon, emit: true },
  { action: 'video', icon: videoIcon },
  { action: 'removeFile', icon: trashIcon, emit: true }
]
